import {Button, Col, Form, message, Modal, Row, Spin, Tabs, Typography,} from "antd";
import {faBuildingColumns, faHome, faPhone} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import './styles.scss';
import AddressChangeRequestComp from "../../components/customerRequests/addressChangeRequestComp";
import ContactDetailsChangeRequestComp from "../../components/customerRequests/contactDetailsChangeRequestComp";
import BankDetailsChangeRequestComp from "../../components/customerRequests/bankDetailsChangeRequestComp";
import ComplaintsRequestComp from "../../components/customerRequests/complaintsRequestComp";
import OtherRequestComp from "../../components/customerRequests/otherRequestComp";
import React, {useEffect, useRef, useState} from "react";
import ComplaintsRequestHistoryComp from "../../components/customerRequests/history/complaintsRequestHistoryComp";
import OtherRequestHistoryComp from "../../components/customerRequests/history/otherRequestHistoryComp";
import ContactDetailsChangeHistoryComp from "../../components/customerRequests/history/contactDetailChangeHistoryComp";
import AddressDetailsChangeHistoryComp from "../../components/customerRequests/history/updateDetailChangeHistoryComp";
import BankDetailsChangeHistoryComp from "../../components/customerRequests/history/updateBankDetailChangeHistoryComp";
import SignatureChangeRequestComp from "../../components/customerRequests/signatureChangeRequestComp";
import SignatureChangeRequestHistoryComp
    from "../../components/customerRequests/history/signatueChangeRequestHistoryComp";
import {requests_img} from "../../../AppImageConst";
import {getLoggedUserCinNumber} from "../../security/KeyclockConfig";
import customerService from "../../service/customerService";
import ErrorHandler from "../../util/ErrorHandler";
import {InputOTP} from "antd-input-otp";
import {OtpDataDto} from "../../dto/OtpDataDto";
import {clearTimeout, setTimeout} from "worker-timers";
import {load} from "worker-timers-broker";
import signupService from "../../service/signupService";
import {
    MSG_OTP_IS_INVALID,
    MSG_OTP_SEND_FAILURE_ERROR,
    MSG_OTP_VERIFICATION_FAILURE_ERROR,
    MSG_OTP_VERIFICATION_SUCCESS
} from "../../util/Messages";
import {ValidateOtpDto} from "../../dto/ValidateOtpDto";
import customerChangeRequestService from "../../service/customerChangeRequestService";
import modal from "antd/es/modal";
import {ExclamationCircleOutlined} from "@ant-design/icons";

const TabPane = Tabs;
const CustomerRequestsPage = () => {
    const [customerCin, setCustomerCin] = useState("")
    const [activeKey, setActiveKey] = useState('1');
    const [addressChangeActiveKey, setAddressChangeActiveKey] = useState('1');
    const [contactChangeActiveKey, setContactChangeActiveKey] = useState('1');
    const [signatureChangeActiveKey, setSignatureChangeActiveKey] = useState('1');
    const [bankChangeActiveKey, setBankChangeActiveKey] = useState('1');
    const [otpData, setOtpData] = useState<OtpDataDto>({
        message: "",
        otpRef: "",
        refId: "",
        retryCount: 0,
        tokenLength: 6,
        validityPeriod: 120,
        resendPeriod: 120,
        tokenType: "numeric",
    });
    type otpInputType =
        "numeric"
        | "alphabet"
        | "symbol"
        | "alphabet-symbol"
        | "alphabet-numeric"
        | "numeric-symbol"
        | "all";
    const otpApplicationId: string | undefined = process.env.OTP_APPLICATION_ID ? process.env.OTP_APPLICATION_ID : "";
    const otpFormRef: React.RefObject<HTMLFormElement> = React.createRef();
    const [value, setValue] = useState([]);
    const [isResendDisable, setIsResendDisable] = useState(true);
    const [isVerified, setVerified] = useState(false);
    const [timer, setTimer] = useState("");
    const timeoutRef = useRef<load>();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [otpDestination, setOtpDestination] = useState({type: "", destination: "", maskedDestination: ""});
    const [contactDetails, setContactDetails] = useState({maskedMobileNo: "", maskedEmail: ""})


    const countdown = (enable: boolean) => {
        let seconds = otpData.resendPeriod;
        setTimer("0:00")

        function tick() {
            const minutesRemaining = Math.floor(seconds / 60);
            const secondsRemaining = seconds % 60;
            --seconds;
            setTimer(`${minutesRemaining.toString().padStart(2, '0')}:${secondsRemaining.toString().padStart(2, '0')}`);
            if (seconds >= 0) {
                timeoutRef.current = setTimeout(tick, 1000);
                setIsResendDisable(true);
            } else {
                setIsResendDisable(false);
            }
        }

        if (enable) {
            tick()
        } else {
            if (typeof timeoutRef.current === "number") {
                clearTimeout(timeoutRef.current);
            }
        }
    }
    const handleCancel = () => {
        countdown(false)
        window.location.replace('/workflow/customer/dashboard')
    };

    const generateMobileOrEmail = () => {

        otpFormRef.current?.resetFields();
        setValue([])

        customerChangeRequestService.generateChangeRequestOtp().then((res: any) => {
            if (res.data !== null) {
                let otpData: OtpDataDto = res.data.results;
                setOtpData(otpData)
                setIsModalOpen(true)
                countdown(true)
            } else {
                message.error(MSG_OTP_SEND_FAILURE_ERROR).then();

            }
        }, (reason) => {
            ErrorHandler.handleError(reason);

        })
    }

    const validateOtp = () => {
        let userOtp = otpFormRef.current?.getFieldValue("userOtp");
        if (!userOtp || userOtp.includes(undefined) || userOtp.includes("") || userOtp.length != otpData.tokenLength) {
            return otpFormRef.current?.setFields([
                {
                    name: "userOtp",
                    errors: [MSG_OTP_IS_INVALID]
                }
            ]);

        } else {
            let validateOtpDto: ValidateOtpDto = {
                refId: otpData.refId,
                appId: otpApplicationId,
                otp: userOtp.join(''),
                otpRef: otpData.otpRef
            }
            signupService.validateOtp(validateOtpDto).then((res: any) => {
                if (res.data !== null && res.data.status == "SUCCESS") {
                    message.success(MSG_OTP_VERIFICATION_SUCCESS).then();
                    handleOk();
                    countdown(false)
                } else {
                    message.error(MSG_OTP_VERIFICATION_FAILURE_ERROR).then();
                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
            })
        }
    }

    const handleOk = () => {
        setIsModalOpen(false);
        setVerified(true);
    };
    const handleTabChange = (key: string) => {
        setActiveKey(key);
        setBankChangeActiveKey("1");
        setSignatureChangeActiveKey("1");
        setContactChangeActiveKey("1");
        setAddressChangeActiveKey("1");
    };

    const handleAddressChangeTabChange = (key: string) => {
        setAddressChangeActiveKey(key);
    };
    const handleContactChangeTabChange = (key: string) => {
        setContactChangeActiveKey(key);
    };
    const handleSignatureChangeTabChange = (key: string) => {
        setSignatureChangeActiveKey(key);
    };
    const handleBankChangeTabChange = (key: string) => {
        setBankChangeActiveKey(key);
    };
    useEffect(() => {

        openConfirmation()

    }, [])

    const openConfirmation = () => {
        modal.confirm({
            title: 'Confirm',
            icon: <ExclamationCircleOutlined/>,
            content: (
                <div>
                    <p>Do you want to navigate to the Change Requests?</p>
                    <p style={{fontSize: '12px', color: '#888888', marginTop: '10px'}}>
                        This action will trigger an OTP message to your contact details.
                    </p>
                </div>
            ),
            okText: 'Yes',
            cancelText: 'No',
            className: 'confirm-dialog-box',
            okButtonProps: {style: {background: '#FF7400'}},
            onOk() {
                getLoggedUserCIN();
            },
            onCancel() {
                window.location.replace('/workflow/customer/dashboard')
            },
        });
    }
    const getLoggedUserCIN = () => {
        let cinNumber = getLoggedUserCinNumber();
        if (undefined != cinNumber) {
            setCustomerCin(cinNumber)
            if (!isVerified) {
                getCustomerContactDetails(cinNumber)
            }
        } else {
            customerService.getCustomerCINByLoggedUser().then(res => {
                cinNumber = res.data.results;
                setCustomerCin(cinNumber)
                if (!isVerified) {
                    getCustomerContactDetails(cinNumber)
                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
            })
        }

    }

    const getCustomerContactDetails = (cinNumber: string) => {
        customerChangeRequestService.getCustomerContactDetailsList(cinNumber).then((res) => {
            let contactDto = res.data.results;
            if (contactDto) {
                let maskedValues = {
                    maskedEmail: maskEmailAndMobileNumber(contactDto.email),
                    maskedMobileNo: maskEmailAndMobileNumber(contactDto.mobileNumber.replaceAll(' ', '').replaceAll('+', ""))
                }
                setContactDetails(maskedValues)
                generateMobileOrEmail()
            } else {
                console.log("Customer contact detail fetch failure")
            }
        }).catch(reason => {
            ErrorHandler.handleError(reason)
        })
    }

    const maskEmailAndMobileNumber = (value: string) => {
        let isEmail = value.includes("@");
        let valueArr: string[];
        valueArr = value.split('');
        let finalArr: string[] = [];
        let len = value.indexOf('@') > -1 ? value.indexOf('@') : value.length - 2;
        if (isEmail) {
            valueArr.forEach((item: any, pos: number) => {
                (pos >= 1 && pos <= len - 2) ? finalArr.push('*') : finalArr.push(valueArr[pos]);
            })
            return finalArr.join('');
        } else {
            valueArr.forEach((item: any, pos: number) => {
                (pos <= len - 2) ? finalArr.push('*') : finalArr.push(valueArr[pos]);
            })
            return finalArr.join('');

        }
    }
    return (
        <div>
            {isVerified ?
                <div>

                    <Row gutter={[16, 16]}>
                        <Col xs={24} sm={24} md={24} lg={24} xl={24} className='page-header-main-title-col'>
                            <h2 className='page-header-main-title'
                                style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                                <div className='header_icon header-icon-center'>
                                    <img style={{height: 28, width: 28}} src={requests_img}
                                         alt=""/>
                                </div>
                                Requests & Update Your Details
                            </h2>
                        </Col>
                    </Row>
                    {
                        customerCin ?
                            <Row gutter={[16, 16]} className='' style={{marginTop: 8}}>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24} className='requests-tabs'>
                                    <Tabs defaultActiveKey="1" tabPosition={'left'} type={'card'}
                                          onChange={handleTabChange}>
                                        <TabPane key={1} tab={'Update Address Details'}
                                                 icon={<FontAwesomeIcon icon={faHome}/>}>
                                            <div className="tabpane-content">
                                                {activeKey === '1' &&
                                                    <Row>
                                                        <Col xs={24} lg={24} md={24} sm={24} className={"detailed_tab"}>
                                                            <Tabs type="card" activeKey={addressChangeActiveKey}
                                                                  defaultActiveKey={['1']}
                                                                  onChange={handleAddressChangeTabChange}>
                                                                <TabPane tab={<>Update Address Details</>}
                                                                         key={1}>
                                                                    <Row className={"margin_top_5"}>
                                                                        <Col lg={24}>
                                                                            {addressChangeActiveKey === '1' &&
                                                                                <AddressChangeRequestComp
                                                                                    cin={customerCin}/>}
                                                                        </Col>
                                                                    </Row>
                                                                </TabPane>
                                                                <TabPane tab={<>History</>}
                                                                         key={2}>
                                                                    <Row className={"margin_top_5"}>
                                                                        <Col lg={24}>
                                                                            {addressChangeActiveKey === '2' &&
                                                                                <AddressDetailsChangeHistoryComp
                                                                                    cin={customerCin}
                                                                                    handleTabChange={handleAddressChangeTabChange}/>}
                                                                        </Col>
                                                                    </Row>
                                                                </TabPane>
                                                            </Tabs>
                                                        </Col>
                                                    </Row>}

                                            </div>
                                        </TabPane>
                                        <TabPane key={2} tab={'Update Contact Details'}
                                                 icon={<FontAwesomeIcon icon={faPhone}/>}>
                                            <div className="tabpane-content">
                                                {activeKey === '2' &&
                                                    <Row>
                                                        <Col xs={24} lg={24} md={24} sm={24} className={"detailed_tab"}>
                                                            <Tabs type="card" activeKey={contactChangeActiveKey}
                                                                  defaultActiveKey={['1']}
                                                                  onChange={handleContactChangeTabChange}>
                                                                <TabPane tab={<>Update Contact Details</>}
                                                                         key={1}>
                                                                    <Row className={"margin_top_5"}>
                                                                        <Col lg={24}>
                                                                            {contactChangeActiveKey === '1' &&
                                                                                <ContactDetailsChangeRequestComp
                                                                                    cin={customerCin}/>}
                                                                        </Col>
                                                                    </Row>
                                                                </TabPane>
                                                                <TabPane tab={<>History</>}
                                                                         key={2}>
                                                                    <Row className={"margin_top_5"}>
                                                                        <Col lg={24}>
                                                                            {contactChangeActiveKey === '2' &&
                                                                                <ContactDetailsChangeHistoryComp
                                                                                    cin={customerCin}
                                                                                    handleTabChange={handleContactChangeTabChange}/>}
                                                                        </Col>
                                                                    </Row>
                                                                </TabPane>
                                                            </Tabs>
                                                        </Col>
                                                    </Row>}
                                            </div>
                                        </TabPane>
                                        <TabPane key={3} tab={'Update Bank Details'}
                                                 icon={<FontAwesomeIcon icon={faBuildingColumns}/>}>
                                            <div className="tabpane-content">
                                                {activeKey === '3' &&
                                                    <Row>
                                                        <Col xs={24} lg={24} md={24} sm={24} className={"detailed_tab"}>
                                                            <Tabs type="card" activeKey={bankChangeActiveKey}
                                                                  defaultActiveKey={['1']}
                                                                  onChange={handleBankChangeTabChange}>
                                                                <TabPane tab={<>Update Bank Details</>}
                                                                         key={1}>
                                                                    <Row className={"margin_top_5"}>
                                                                        <Col lg={24}>
                                                                            {bankChangeActiveKey === '1' &&
                                                                                <BankDetailsChangeRequestComp
                                                                                    cin={customerCin}/>}
                                                                        </Col>
                                                                    </Row>
                                                                </TabPane>
                                                                <TabPane tab={<>History</>}
                                                                         key={2}>
                                                                    <Row className={"margin_top_5"}>
                                                                        <Col lg={24}>

                                                                            {bankChangeActiveKey === '2' &&
                                                                                <BankDetailsChangeHistoryComp
                                                                                    handleTabChange={handleBankChangeTabChange}
                                                                                    cin={customerCin}/>}
                                                                        </Col>
                                                                    </Row>
                                                                </TabPane>
                                                            </Tabs>
                                                        </Col>
                                                    </Row>
                                                }
                                            </div>
                                        </TabPane>
                                        <TabPane key={5} tab={'Update Signature'}
                                                 icon={<div className='tab-pane-sign-change-icon'></div>}>
                                            <div className="tabpane-content">
                                                {activeKey === '5' &&
                                                    <Row>
                                                        <Col xs={24} lg={24} md={24} sm={24} className={"detailed_tab"}>
                                                            <Tabs type="card" activeKey={signatureChangeActiveKey}
                                                                  defaultActiveKey={['1']}
                                                                  onChange={handleSignatureChangeTabChange}>
                                                                <TabPane tab={<>Update Signature</>}
                                                                         key={1}>
                                                                    <Row className={"margin_top_5"}>
                                                                        <Col lg={24}>
                                                                            {signatureChangeActiveKey === '1' &&
                                                                                <SignatureChangeRequestComp
                                                                                    cin={customerCin}/>}
                                                                        </Col>
                                                                    </Row>
                                                                </TabPane>
                                                                <TabPane tab={<>History</>}
                                                                         key={2}>
                                                                    <Row className={"margin_top_5"}>
                                                                        <Col lg={24}>
                                                                            {signatureChangeActiveKey === '2' &&
                                                                                <SignatureChangeRequestHistoryComp
                                                                                    handleTabChange={handleSignatureChangeTabChange}
                                                                                    cin={customerCin}/>}
                                                                        </Col>
                                                                    </Row>
                                                                </TabPane>
                                                            </Tabs>
                                                        </Col>
                                                    </Row>
                                                }
                                            </div>
                                        </TabPane>
                                        <TabPane key={6} tab={'Complaints'}
                                                 icon={<div className='tab-pane-complaint-icon'></div>}>
                                            <div className="tabpane-content">
                                                {activeKey === '6' &&
                                                    <Row>
                                                        <Col xs={24} lg={24} md={24} sm={24} className={"detailed_tab"}>
                                                            <Tabs type="card" defaultActiveKey={['1']}>
                                                                <TabPane tab={<>Lodge a Complaint</>}
                                                                         key="1">
                                                                    <Row className={"margin_top_5"}>
                                                                        <Col lg={24}>
                                                                            <ComplaintsRequestComp cin={customerCin}/>
                                                                        </Col>
                                                                    </Row>
                                                                </TabPane>
                                                                <TabPane tab={<>History</>}
                                                                         key="2">
                                                                    <Row className={"margin_top_5"}>
                                                                        <Col lg={24}>
                                                                            <ComplaintsRequestHistoryComp
                                                                                cin={customerCin}/>
                                                                        </Col>
                                                                    </Row>
                                                                </TabPane>
                                                            </Tabs>
                                                        </Col>
                                                    </Row>
                                                }
                                            </div>
                                        </TabPane>
                                        <TabPane key={7} tab={'Other Requests'}
                                                 icon={<div className='tab-pane-other-request-icon'></div>}>
                                            <div className="tabpane-content">
                                                {activeKey === '7' &&
                                                    <Row>
                                                        <Col xs={24} lg={24} md={24} sm={24} className={"detailed_tab"}>
                                                            <Tabs type="card" defaultActiveKey={['1']}>
                                                                <TabPane tab={<>Lodge an Other Request</>}
                                                                         key="1">
                                                                    <Row className={"margin_top_5"}>
                                                                        <Col lg={24}>
                                                                            <OtherRequestComp cin={customerCin}/>
                                                                        </Col>
                                                                    </Row>
                                                                </TabPane>
                                                                <TabPane tab={<>History</>}
                                                                         key="2">
                                                                    <Row className={"margin_top_5"}>
                                                                        <Col lg={24}>
                                                                            <OtherRequestHistoryComp cin={customerCin}/>
                                                                        </Col>
                                                                    </Row>
                                                                </TabPane>
                                                            </Tabs>
                                                        </Col>
                                                    </Row>

                                                }

                                            </div>
                                        </TabPane>
                                        {/*<TabPane key={8} tab={'My Requests'}*/}
                                        {/*         icon={<FontAwesomeIcon icon={faList}/>}>*/}
                                        {/*    <div className="tabpane-content">*/}
                                        {/*        <MyRequestListComp/>*/}
                                        {/*    </div>*/}
                                        {/*</TabPane>*/}
                                    </Tabs>

                                </Col>
                            </Row> :
                            <div className="loader-container">
                                <Spin size="large" tip="Loading"></Spin>
                            </div>
                    }
                </div>
                :
                <Modal title="OTP VERIFICATION"
                       open={isModalOpen}
                       destroyOnClose={true}
                       maskClosable={false}
                       closable={false}
                       centered
                       className='otp-verification-modal'
                       footer={[
                           <Button
                               // disabled={isResendDisable}
                               onClick={handleCancel}
                               className='otp-close-btn'>Close</Button>,
                           <Button type="success" onClick={validateOtp}
                                   className='otp-verify-btn'>Verify</Button>,
                       ]}>
                    <p className='otp-sent-info'>Enter the OTP sent
                        to <b>{contactDetails.maskedEmail}</b> and <b>{contactDetails.maskedMobileNo}</b></p>

                    <Form name="complex-form" ref={otpFormRef}>
                        <Form.Item>

                            <Form.Item
                                noStyle
                                name="userOtp"
                                rules={[{validator: async () => Promise.resolve()}]}
                            >
                                <InputOTP length={otpData.tokenLength}
                                          inputType={otpData.tokenType.toLowerCase() as otpInputType}
                                          onChange={() => setValue}
                                          value={value}/>
                            </Form.Item>

                            <Typography href="#API">
                                <p>Didn't you receive the OTP?
                                    <Button type="link" disabled={isResendDisable}
                                            onClick={generateMobileOrEmail}>
                                        Resend
                                    </Button>
                                    <span style={{float: 'right', paddingTop: 4}}>{timer}</span>
                                </p>
                            </Typography>


                        </Form.Item>
                    </Form>

                </Modal>
            }
        </div>
    )
}
export default CustomerRequestsPage